// コース選択
export const courseOptions = [
    "Sコース (全部)",
    "Aコース (全部)"
];

// Sコース detail
export const sCourseOptions = [
    "Sコース全部",
    "速習1",
    "速習2",
    "速習3",
    "速習4",
    "速習5",
    "速習6",
    "速習7",
    "速習8",
    "速習9",
    "速習10"
];

// Aコース detail  
export const aCourseOptions = [
    "Aコース全部",
    "速習1", 
    "速習2", 
    "速習3"
];

// 日英表示順選択
export const languageOptions = [
    "日 → 英",
    "英 → 日",
    "日のみ",
    "英のみ"
];

// AIEnglish（旅行英語）用 日英表示順
export const aiEnglishLanguageOptions = [
    "相手→自分(空白)",
    "自分→相手(空白)"
];

// ChildEnglish用 表示順
export const childEnglishLanguageOptions = [
    "相手→自分(空白)",
    "自分→相手(空白)"
];

export const childEnglishStandardOptions = [
    "日 → 英",
    "英 → 日",
    "日のみ",
    "英のみ"
];

// 表示間隔選択
export const intervalOptions = [
    "0秒",
    "0.3秒",
    "0.5秒",
    "1秒",
    "2秒",
    "3秒",
    "4秒",
    "5秒",
    "10秒"
];

// Interval options mapping
export const intervalMapping = {
    "0秒": 0,
    "0.3秒": 0.3,
    "0.5秒": 0.5,
    "1秒": 1,
    "2秒": 2,
    "3秒": 3,
    "4秒": 4,
    "5秒": 5,
    "10秒": 10
};

// めくり方選択
export const flipOptions = [
    "オート1\n(聞き流し)",
    "マニュアル\n(手動テスト)",
    "オート2\n(自動テスト)"
];

// ランダム再生有無選択
export const randomPlayOptions = [
    "順番",
    "ランダム"
];

export const randomPlayMapping = {
    "順番": false,
    "ランダム": true
}

// 音声再生速度選択
export const speedOptions = [
    "通常",
    "1.2倍速",
    "1.5倍速",
    "1.7倍速",
    "2倍速",
    "2.5倍速",
    "3倍速",
    "3.5倍速"
];

// Speed options mapping
export const speedMapping = {
    "通常": 1.0,
    "1.2倍速": 1.2,
    "1.5倍速": 1.5,
    "1.7倍速": 1.7,
    "2倍速": 2.0,
    "2.5倍速": 2.5,
    "3倍速": 3.0,
    "3.5倍速": 3.5
};

export const aiEnglishDisplayLabels = {
    "相手→自分(空白)": "相手→自分（？クイズ）",
    "自分→相手(空白)": "自分→相手（？クイズ）"
};

export const childEnglishDisplayLabels = {
    "相手→自分(空白)": "相手（大人）→自分（？クイズ）",
    "自分→相手(空白)": "自分（子供）→相手（？クイズ）"
};
